import React,{useState} from "react";
import Breadcumb from '../../components/Breadcumb/Breadcumb'
import { useDropzone } from 'react-dropzone';
import { Images } from "../../helpers";
import Button from '@material-ui/core/Button';
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import CircularProgress from '@material-ui/core/CircularProgress';
import { Alerts } from "../../helpers";
const BreadcrumbData = [
  {
    id: 1,
    page_title: "Dashboard",
    page_path: "/",
    icon: "tachometer",
  },
  {
    id: 2,
    page_title: "Upload Images",
    page_path: "/",
    icon: "tachometer",
  }
]

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  paper: {
    padding: theme.spacing(2),
    color: theme.palette.text.secondary,
  },
  formHeading:{
    fontSize:'20px !important',
    marginTop:0,
    marginBottom:10,
    textTransform:"uppercase",
    fontWeight:600
  }
}));

const UploadImages = () => {
  const [isLoading, setLoading] = useState(false);
  const classes = useStyles();
  const { acceptedFiles, getRootProps, getInputProps } = useDropzone();

  let files = acceptedFiles.map(file => (
    <li key={file.name}>
      {file.name} - {file.size} bytes
    </li>
  ));

  const handleUploadImage = async (e) => {
    e.preventDefault()
    setLoading(true)
    let formData = new FormData()
    for (let i = 0; i < acceptedFiles.length; i++) {
      formData.append("images", acceptedFiles[i]);
    }
    let resp = await Images.uploadImage(formData);
    if (resp) {
      if(resp.status === 200){
       
      }
      Alerts.alertMessage(resp.message, "", "success");
       setLoading(false)
      console.log(acceptedFiles);
    }

  }


  return (
    <>
      <Breadcumb items={BreadcrumbData} />
      <div className="page-wrapper pd30">
      <div className={classes.root}>
       
      <Grid container spacing={3}>
       
        <Grid item xs={6}>
          <Paper className={classes.paper}>
          <h3 className={classes.formHeading}>Upload Images</h3>
          <section className="container">
          <div {...getRootProps({ className: 'dropzone disabled' })}>
            <input {...getInputProps()} />
            <p>Drag 'n' drop some files here, or click to select files</p>
          </div>
          <aside>
            <h6 style={{ margin: 10 }}>Files</h6>
            <ul>{files}</ul>
          </aside>
        </section>
        <Button type="button" onClick={handleUploadImage} variant="contained" color="primary">
          {
            isLoading ? <CircularProgress color="secondary" size={20}/> : ' Upload Now'
          }
         
        </Button>
          </Paper>
        </Grid>
      </Grid>
    </div>
        
      </div>
    </>
  )
}

export default UploadImages